import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  selector: 'sbnb-linkbase',
  templateUrl: './linkbase.component.html',
})
export class LinkbaseComponent {
  AppPermission = AppPermission;
  isMobile$ = this.deviceDetectionService.isMobileViewport();
  images: string[] = [];

  constructor(private deviceDetectionService: DeviceDetectionService) {
    this.isMobile$.subscribe((isMobile) => {
      this.images = isMobile
        ? [
            '/assets/images/apps/linkbase/1.jpg',
            '/assets/images/apps/linkbase/2.jpg',
            '/assets/images/apps/linkbase/3.jpg',
            '/assets/images/apps/linkbase/4.jpg',
          ]
        : [
            '/assets/images/apps/linkbase/5.jpg',
            '/assets/images/apps/linkbase/6.jpg',
            '/assets/images/apps/linkbase/7.jpg',
            '/assets/images/apps/linkbase/8.jpg',
          ];
    });
  }
}
